import React, { useState } from 'react';
import { GradientHero } from '../components/GradientHero';
import { TrustBadges } from '../components/TrustBadges';
import { Button } from '../components/Button';
import { StarIcon, QuoteIcon, ClockIcon, MessageSquareIcon, PhoneIcon, BellIcon, HelpCircleIcon, CalendarIcon, CheckIcon, PhoneForwardedIcon, MessageCircleIcon, CalendarCheckIcon, ZapIcon, WorkflowIcon, DatabaseIcon, BrainCircuitIcon, ChevronDownIcon } from 'lucide-react';
function BoltValueProposition() {
  const benefits = [{
    icon: ClockIcon,
    title: '24/7 Instant Call Answering',
    description: 'Never miss a call again with round-the-clock AI coverage that picks up instantly'
  }, {
    icon: MessageSquareIcon,
    title: 'Customised Company Greeting',
    description: 'Fully branded experience that sounds like your business, not a generic service'
  }, {
    icon: PhoneIcon,
    title: 'Accurate Capture',
    description: 'Precise name, number, and message recording with intelligent transcription'
  }, {
    icon: BellIcon,
    title: 'Real-Time Call Summaries',
    description: 'Instant notifications with complete call context delivered immediately'
  }, {
    icon: HelpCircleIcon,
    title: 'FAQ Handling',
    description: 'Answer common questions with fenced, brand-safe responses automatically'
  }, {
    icon: CalendarIcon,
    title: 'Appointment Booking',
    description: 'Seamless calendar integration for automated scheduling and confirmations'
  }];
  return <section className="w-full bg-[#0F0F0F] py-28 md:py-36 relative overflow-hidden" data-id="element-589">
      {/* Gradient accents */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#F1B530] opacity-10 rounded-full blur-3xl" data-id="element-590"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#D09F2B] opacity-10 rounded-full blur-3xl" data-id="element-591"></div>

      <div className="max-w-7xl mx-auto px-8 md:px-12 relative z-10" data-id="element-592">
        <div className="text-center mb-20" data-id="element-593">
          <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl lg:text-6xl mb-6 tracking-tight" data-id="element-594">
            <span className="bg-gradient-to-r from-[#F5F5F5] via-[#F1B530] to-[#F5F5F5] bg-clip-text text-transparent" data-id="element-595">
              Why Choose Our AI Answering Service?
            </span>
          </h2>
          <p className="font-['Inter'] font-light text-xl md:text-2xl text-[#A0A0A0]" data-id="element-596">
            Your Always-On Receptionist, without the overheads
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-597">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <div key={index} className="group relative bg-gradient-to-br from-[#1A1A1A] to-[#0F0F0F] rounded-2xl p-8 border border-[#2A2A2A] hover:border-[#F1B530]/50 transition-all duration-500 hover:-translate-y-2" data-id="element-598">
                {/* Gradient glow on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-[#F1B530]/0 to-[#F1B530]/0 group-hover:from-[#F1B530]/5 group-hover:to-[#D09F2B]/5 rounded-2xl transition-all duration-500" data-id="element-599"></div>

                <div className="relative" data-id="element-600">
                  {/* Icon with gradient background */}
                  <div className="w-16 h-16 bg-gradient-to-br from-[#F1B530] to-[#D09F2B] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-601">
                    <Icon className="w-8 h-8 text-[#0F0F0F]" data-id="element-602" />
                  </div>

                  <h3 className="font-['Inter'] font-semibold text-xl text-[#F5F5F5] mb-4 group-hover:text-[#F1B530] transition-colors duration-300" data-id="element-603">
                    {benefit.title}
                  </h3>

                  <p className="font-['Inter'] text-[#A0A0A0] leading-relaxed font-light" data-id="element-604">
                    {benefit.description}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}
function BoltFeatureShowcase() {
  return <section className="w-full bg-[#1A1A1A] py-28 md:py-36 relative overflow-hidden" data-id="element-605">
      {/* Gradient accents */}
      <div className="absolute top-20 right-20 w-64 h-64 bg-[#F1B530] opacity-10 rounded-full blur-3xl" data-id="element-606"></div>
      <div className="absolute bottom-40 left-20 w-80 h-80 bg-[#D09F2B] opacity-10 rounded-full blur-3xl" data-id="element-607"></div>

      <div className="max-w-7xl mx-auto px-8 md:px-12 relative z-10" data-id="element-608">
        {/* Feature 1 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-32" data-id="element-609">
          <div className="relative group" data-id="element-610">
            <div className="absolute inset-0 bg-gradient-to-r from-[#F1B530] to-[#D09F2B] rounded-3xl opacity-20 blur-xl group-hover:opacity-30 transition-opacity duration-500" data-id="element-611"></div>
            <div className="relative aspect-[4/3] rounded-3xl overflow-hidden border border-[#2A2A2A]" data-id="element-612">
              <img src="https://images.unsplash.com/photo-1551434678-e076c223a692?w=1200&q=80" alt="Real-time dashboard" className="w-full h-full object-cover" data-id="element-613" />
            </div>
            <div className="absolute -bottom-8 -right-8 bg-gradient-to-br from-[#F1B530] to-[#D09F2B] rounded-2xl p-6 shadow-2xl" data-id="element-614">
              <div className="font-['Poppins'] text-4xl font-bold text-[#0F0F0F] mb-1" data-id="element-615">
                100%
              </div>
              <div className="font-['Inter'] text-sm text-[#0F0F0F] font-semibold" data-id="element-616">
                Capture Rate
              </div>
            </div>
          </div>

          <div data-id="element-617">
            <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl text-[#F5F5F5] mb-6 bg-gradient-to-r from-[#F5F5F5] to-[#F1B530] bg-clip-text text-transparent" data-id="element-618">
              Real-Time Dashboard & Analytics
            </h2>
            <p className="font-['Inter'] text-lg text-[#A0A0A0] mb-8 leading-relaxed font-light" data-id="element-619">
              Monitor every call in real-time with comprehensive analytics.
              Track call volume, response times, customer satisfaction, and
              conversion rates all in one intuitive dashboard.
            </p>
            <ul className="space-y-4 mb-8" data-id="element-620">
              <li className="flex items-start" data-id="element-621">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-622">•</span>
                <span className="font-['Inter'] text-[#F5F5F5] font-light" data-id="element-623">
                  Live call monitoring and notifications
                </span>
              </li>
              <li className="flex items-start" data-id="element-624">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-625">•</span>
                <span className="font-['Inter'] text-[#F5F5F5] font-light" data-id="element-626">
                  Detailed call transcripts and recordings
                </span>
              </li>
              <li className="flex items-start" data-id="element-627">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-628">•</span>
                <span className="font-['Inter'] text-[#F5F5F5] font-light" data-id="element-629">
                  Performance metrics and insights
                </span>
              </li>
            </ul>
            <Button data-id="element-630">Explore Dashboard</Button>
          </div>
        </div>

        {/* Feature 2 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-32" data-id="element-631">
          <div className="lg:order-2 relative group" data-id="element-632">
            <div className="absolute inset-0 bg-gradient-to-r from-[#D09F2B] to-[#F1B530] rounded-3xl opacity-20 blur-xl group-hover:opacity-30 transition-opacity duration-500" data-id="element-633"></div>
            <div className="relative aspect-[4/3] rounded-3xl overflow-hidden border border-[#2A2A2A]" data-id="element-634">
              <img src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1200&q=80" alt="Integrations" className="w-full h-full object-cover" data-id="element-635" />
            </div>
            <div className="absolute -bottom-8 -left-8 bg-[#252525] border-2 border-[#F1B530] rounded-2xl p-6 shadow-2xl" data-id="element-636">
              <div className="font-['Poppins'] text-4xl font-bold text-[#F1B530] mb-1" data-id="element-637">
                50+
              </div>
              <div className="font-['Inter'] text-sm text-[#F5F5F5] font-semibold" data-id="element-638">
                Integrations
              </div>
            </div>
          </div>

          <div className="lg:order-1" data-id="element-639">
            <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl text-[#F5F5F5] mb-6 bg-gradient-to-r from-[#F5F5F5] to-[#F1B530] bg-clip-text text-transparent" data-id="element-640">
              Seamless CRM & Tool Integration
            </h2>
            <p className="font-['Inter'] text-lg text-[#A0A0A0] mb-8 leading-relaxed font-light" data-id="element-641">
              Connect with your existing tools effortlessly. Our AI integrates
              with popular CRMs, calendars, and business tools to keep your
              workflow smooth and data synchronized.
            </p>
            <ul className="space-y-4 mb-8" data-id="element-642">
              <li className="flex items-start" data-id="element-643">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-644">•</span>
                <span className="font-['Inter'] text-[#F5F5F5] font-light" data-id="element-645">
                  Salesforce, HubSpot, Zoho CRM
                </span>
              </li>
              <li className="flex items-start" data-id="element-646">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-647">•</span>
                <span className="font-['Inter'] text-[#F5F5F5] font-light" data-id="element-648">
                  Google Calendar, Outlook, Calendly
                </span>
              </li>
              <li className="flex items-start" data-id="element-649">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-650">•</span>
                <span className="font-['Inter'] text-[#F5F5F5] font-light" data-id="element-651">
                  Slack, Teams, Zapier, and more
                </span>
              </li>
            </ul>
            <Button data-id="element-652">View All Integrations</Button>
          </div>
        </div>

        {/* Feature 3 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-653">
          <div className="relative group" data-id="element-654">
            <div className="absolute inset-0 bg-gradient-to-r from-[#F1B530] to-[#D09F2B] rounded-3xl opacity-20 blur-xl group-hover:opacity-30 transition-opacity duration-500" data-id="element-655"></div>
            <div className="relative aspect-[4/3] rounded-3xl overflow-hidden border border-[#2A2A2A]" data-id="element-656">
              <img src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1200&q=80" alt="AI training" className="w-full h-full object-cover" data-id="element-657" />
            </div>
            <div className="absolute -bottom-8 -right-8 bg-[#252525] border-2 border-[#F1B530] rounded-2xl p-6 shadow-2xl" data-id="element-658">
              <div className="font-['Poppins'] text-4xl font-bold text-[#F1B530] mb-1" data-id="element-659">
                &lt;5min
              </div>
              <div className="font-['Inter'] text-sm text-[#F5F5F5] font-semibold" data-id="element-660">
                Setup Time
              </div>
            </div>
          </div>

          <div data-id="element-661">
            <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl text-[#F5F5F5] mb-6 bg-gradient-to-r from-[#F5F5F5] to-[#F1B530] bg-clip-text text-transparent" data-id="element-662">
              Custom AI Training for Your Business
            </h2>
            <p className="font-['Inter'] text-lg text-[#A0A0A0] mb-8 leading-relaxed font-light" data-id="element-663">
              Train your AI receptionist with your business knowledge, FAQs, and
              specific protocols. The more you customize, the more natural and
              helpful your AI becomes.
            </p>
            <ul className="space-y-4 mb-8" data-id="element-664">
              <li className="flex items-start" data-id="element-665">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-666">•</span>
                <span className="font-['Inter'] text-[#F5F5F5] font-light" data-id="element-667">
                  Upload FAQs and knowledge base
                </span>
              </li>
              <li className="flex items-start" data-id="element-668">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-669">•</span>
                <span className="font-['Inter'] text-[#F5F5F5] font-light" data-id="element-670">
                  Define custom call routing rules
                </span>
              </li>
              <li className="flex items-start" data-id="element-671">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-672">•</span>
                <span className="font-['Inter'] text-[#F5F5F5] font-light" data-id="element-673">
                  Set brand voice and tone guidelines
                </span>
              </li>
            </ul>
            <Button data-id="element-674">Start Customizing</Button>
          </div>
        </div>
      </div>
    </section>;
}
function BoltIndustryBenefits() {
  const industries = [{
    name: 'Healthcare',
    benefits: ['HIPAA compliant', 'Appointment scheduling', 'Emergency routing', 'Patient messaging']
  }, {
    name: 'Legal',
    benefits: ['Client intake', 'Confidential handling', 'Urgent call screening', 'Case management']
  }, {
    name: 'Real Estate',
    benefits: ['Property inquiries', 'Viewing bookings', 'Lead capture', 'Tenant support']
  }, {
    name: 'Trade Services',
    benefits: ['Job booking', 'Emergency calls', 'Quote requests', 'Service scheduling']
  }, {
    name: 'Retail',
    benefits: ['Order taking', 'Store inquiries', 'Stock checks', 'Customer support']
  }, {
    name: 'Professional Services',
    benefits: ['Client screening', 'Appointment booking', 'Message handling', 'Consultation scheduling']
  }];
  return <section className="w-full bg-[#0F0F0F] py-28 relative overflow-hidden" data-id="element-675">
      {/* Gradient accents */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#F1B530] opacity-10 rounded-full blur-3xl" data-id="element-676"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#D09F2B] opacity-10 rounded-full blur-3xl" data-id="element-677"></div>

      <div className="max-w-7xl mx-auto px-8 md:px-12 relative z-10" data-id="element-678">
        <div className="text-center mb-16" data-id="element-679">
          <h2 className="font-['Poppins'] font-bold text-5xl md:text-6xl mb-6 bg-gradient-to-r from-[#F5F5F5] via-[#F1B530] to-[#F5F5F5] bg-clip-text text-transparent" data-id="element-680">
            Trusted Across Industries
          </h2>
          <p className="font-['Inter'] text-xl text-[#A0A0A0] font-light" data-id="element-681">
            Tailored solutions for every business type
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-682">
          {industries.map((industry, index) => <div key={index} className="group relative bg-gradient-to-br from-[#1A1A1A] to-[#0F0F0F] rounded-2xl p-8 border border-[#2A2A2A] hover:border-[#F1B530]/50 transition-all duration-500" data-id="element-683">
              <div className="absolute inset-0 bg-gradient-to-br from-[#F1B530]/0 to-[#F1B530]/0 group-hover:from-[#F1B530]/5 group-hover:to-[#D09F2B]/5 rounded-2xl transition-all duration-500" data-id="element-684"></div>

              <div className="relative" data-id="element-685">
                <h3 className="font-['Poppins'] font-bold text-2xl text-[#F5F5F5] mb-6 group-hover:text-[#F1B530] transition-colors duration-300" data-id="element-686">
                  {industry.name}
                </h3>
                <ul className="space-y-3" data-id="element-687">
                  {industry.benefits.map((benefit, idx) => <li key={idx} className="font-['Inter'] text-[#A0A0A0] flex items-start" data-id="element-688">
                      <span className="text-[#F1B530] mr-2" data-id="element-689">•</span>
                      {benefit}
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
function BoltPricingPlans() {
  const plans = [{
    name: 'Scout 25',
    price: 'AUD $65',
    calls: '25 calls/month',
    minutes: '125',
    target: 'Perfect for solo operators testing the waters',
    inclusions: ['Instant call pickup', 'Customised company greeting', 'Name, number & message capture', 'Real-time call summaries via SMS/email', 'Call recordings & transcripts', 'Dashboard analytics', 'Excess: $2.60/call or $0.52/min'],
    ctaText: 'Start 7 Day Free Trial',
    ctaLink: 'Listen to call recording'
  }, {
    name: 'Forager 50',
    price: 'AUD $115',
    calls: '50 calls/month',
    minutes: '250',
    target: 'Small teams with steady enquiry flow',
    inclusions: ['Everything in Scout 25', 'Priority support', 'Extended call handling', 'Multi-user dashboard access', 'Custom call routing rules', 'Excess: $2.30/call or $0.46/min'],
    ctaText: 'Try 7 Day Free Trial',
    ctaLink: 'Listen to call recording',
    isPopular: true
  }, {
    name: 'Drift 75',
    price: 'AUD $165',
    calls: '75 calls/month',
    minutes: '375',
    target: 'Growing teams with rising call peaks',
    inclusions: ['Everything in Forager 50', 'Advanced analytics', 'Team collaboration tools', 'Custom integrations', 'Dedicated account manager', 'Excess: $2.20/call or $0.44/min'],
    ctaText: 'Try 7 Day Free Trial',
    ctaLink: 'Listen to call recording'
  }, {
    name: 'Surge 150',
    price: 'AUD $325',
    calls: '150 calls/month',
    minutes: '750',
    target: 'High-tempo operations with regular spikes',
    inclusions: ['Everything in Drift 75', 'Priority call routing', 'Advanced workflow automation', 'Custom reporting', 'API access', 'Excess: $2.17/call or $0.43/min'],
    ctaText: 'Try 7 Day Free Trial',
    ctaLink: 'Listen to call recording'
  }, {
    name: 'Swarm 300',
    price: 'AUD $645',
    calls: '300 calls/month',
    minutes: '1,500',
    target: 'Heavy daily call activity teams',
    inclusions: ['Everything in Surge 150', 'Enterprise-grade security', 'Custom AI training', 'White-label options', 'SLA guarantees', 'Excess: $2.15/call or $0.43/min'],
    ctaText: 'Try 7 Day Free Trial',
    ctaLink: 'Listen to call recording'
  }, {
    name: 'Colony 500',
    price: 'AUD $955',
    calls: '500 calls/month',
    minutes: '2,250',
    target: 'Enterprise-level high-volume operations',
    inclusions: ['Everything in Swarm 300', 'Dedicated infrastructure', 'Custom AI models', 'Advanced compliance features', '24/7 premium support', 'Excess: $1.91/call or $0.42/min'],
    ctaText: 'Try 7 Day Free Trial',
    ctaLink: 'Listen to call recording'
  }, {
    name: 'AI Automation Customisation',
    target: 'For businesses requiring advanced automation and integrations beyond standard plans',
    inclusions: ['Custom call volumes', 'Bespoke AI training', 'Enterprise integrations', 'Advanced workflow automation', 'Dedicated success team', 'Custom SLAs'],
    ctaText: 'Contact Sales',
    isCustom: true
  }];
  return <section className="w-full bg-[#0F0F0F] py-28 md:py-36 relative overflow-hidden" data-id="element-690">
      {/* Subtle dot pattern background */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: 'radial-gradient(circle, #F1B530 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-691"></div>

      <div className="max-w-7xl mx-auto px-8 md:px-12 relative z-10" data-id="element-692">
        <h2 className="font-['Poppins'] font-bold text-5xl md:text-6xl text-[#F5F5F5] text-center mb-6 tracking-tight" data-id="element-693">
          Plans
        </h2>
        <p className="font-['Inter'] text-xl text-[#A0A0A0] text-center mb-20 font-light" data-id="element-694">
          Choose the perfect plan for your business needs
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-695">
          {plans.slice(0, 6).map((plan, index) => <div key={index} className={`bg-[#1A1A1A] rounded-2xl p-10 border transition-all duration-300 hover:-translate-y-1 relative flex flex-col h-full ${plan.isPopular ? 'border-[#F1B530] ring-2 ring-[#F1B530]/20' : 'border-[#2A2A2A] hover:border-[#F1B530]/30'}`} data-id="element-696">
              {plan.isPopular && <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#F1B530] text-[#0F0F0F] px-6 py-2 rounded-full font-['Inter'] font-semibold text-sm" data-id="element-697">
                  Most Popular
                </div>}

              <div className="mb-8" data-id="element-698">
                <h3 className="font-['Poppins'] font-bold text-2xl text-[#F5F5F5] mb-3" data-id="element-699">
                  {plan.name}
                </h3>
                {!plan.isCustom ? <>
                    <div className="mb-3" data-id="element-700">
                      <span className="font-['Poppins'] font-bold text-5xl text-[#F5F5F5]" data-id="element-701">
                        {plan.price}
                      </span>
                      <span className="text-[#A0A0A0] font-['Inter'] ml-2 text-sm" data-id="element-702">
                        plus GST/month
                      </span>
                    </div>
                    <p className="text-[#A0A0A0] font-['Inter'] text-sm mb-2 font-light" data-id="element-703">
                      Up to {plan.calls} • {plan.minutes} free minutes
                    </p>
                  </> : <div className="mb-3" data-id="element-704">
                    <span className="font-['Poppins'] font-bold text-4xl text-[#F5F5F5]" data-id="element-705">
                      Custom Pricing
                    </span>
                  </div>}
                <p className="text-[#A0A0A0] font-['Inter'] text-sm italic font-light" data-id="element-706">
                  {plan.target}
                </p>
              </div>

              <div className="mb-10 flex-grow" data-id="element-707">
                <ul className="space-y-4" data-id="element-708">
                  {plan.inclusions.map((inclusion, idx) => <li key={idx} className="flex items-start" data-id="element-709">
                      <CheckIcon className="w-5 h-5 text-[#F1B530] mr-3 flex-shrink-0 mt-0.5" data-id="element-710" />
                      <span className="font-['Inter'] text-[#F5F5F5] text-sm leading-relaxed font-light" data-id="element-711">
                        {inclusion}
                      </span>
                    </li>)}
                </ul>
              </div>

              <div className="mt-auto" data-id="element-712">
                <Button className="w-full" size="lg" data-id="element-713">
                  {plan.ctaText}
                </Button>

                {plan.ctaLink && <a href="#" className="block text-center mt-5 text-[#A0A0A0] font-['Inter'] text-sm hover:text-[#F1B530] transition-colors duration-300" data-id="element-714">
                    {plan.ctaLink}
                  </a>}
              </div>
            </div>)}
        </div>

        <div className="max-w-2xl mx-auto" data-id="element-715">
          <div className="bg-[#1A1A1A] rounded-2xl p-10 border border-[#2A2A2A] hover:border-[#F1B530]/30 transition-all duration-300 hover:-translate-y-1 flex flex-col h-full" data-id="element-716">
            <div className="mb-8" data-id="element-717">
              <h3 className="font-['Poppins'] font-bold text-2xl text-[#F5F5F5] mb-3" data-id="element-718">
                {plans[6].name}
              </h3>
              <div className="mb-3" data-id="element-719">
                <span className="font-['Poppins'] font-bold text-4xl text-[#F5F5F5]" data-id="element-720">
                  Custom Pricing
                </span>
              </div>
              <p className="text-[#A0A0A0] font-['Inter'] text-sm italic font-light" data-id="element-721">
                {plans[6].target}
              </p>
            </div>

            <div className="mb-10 flex-grow" data-id="element-722">
              <ul className="space-y-4" data-id="element-723">
                {plans[6].inclusions.map((inclusion, idx) => <li key={idx} className="flex items-start" data-id="element-724">
                    <CheckIcon className="w-5 h-5 text-[#F1B530] mr-3 flex-shrink-0 mt-0.5" data-id="element-725" />
                    <span className="font-['Inter'] text-[#F5F5F5] text-sm leading-relaxed font-light" data-id="element-726">
                      {inclusion}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="mt-auto" data-id="element-727">
              <Button className="w-full" size="lg" data-id="element-728">
                {plans[6].ctaText}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function BoltTestimonials() {
  const testimonials = [{
    quote: "This AI answering service has transformed how we handle customer calls. We've seen a 40% increase in captured leads since implementing it.",
    author: 'Sarah Mitchell',
    role: 'CEO, TechStart Solutions',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&q=80',
    rating: 5
  }, {
    quote: 'The 24/7 coverage means we never miss an opportunity. Our customers love the instant response, and so do we.',
    author: 'James Chen',
    role: 'Operations Director, GrowthCo',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80',
    rating: 5
  }, {
    quote: "Setup was incredibly easy, and the AI sounds so natural. It's like having a professional receptionist without the overhead costs.",
    author: 'Emma Thompson',
    role: 'Founder, Bright Ideas Agency',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&q=80',
    rating: 5
  }];
  return <section className="w-full bg-[#1A1A1A] py-28 md:py-36 relative overflow-hidden" data-id="element-729">
      {/* Gradient accents */}
      <div className="absolute top-20 left-20 w-64 h-64 bg-[#F1B530] opacity-10 rounded-full blur-3xl" data-id="element-730"></div>
      <div className="absolute bottom-40 right-20 w-80 h-80 bg-[#D09F2B] opacity-10 rounded-full blur-3xl" data-id="element-731"></div>

      <div className="max-w-7xl mx-auto px-8 md:px-12 relative z-10" data-id="element-732">
        <div className="text-center mb-20" data-id="element-733">
          <h2 className="font-['Poppins'] font-bold text-5xl md:text-6xl text-[#F5F5F5] mb-6 bg-gradient-to-r from-[#F5F5F5] via-[#F1B530] to-[#F5F5F5] bg-clip-text text-transparent" data-id="element-734">
            Trusted by Growing Businesses
          </h2>
          <p className="font-['Inter'] text-xl text-[#A0A0A0] font-light" data-id="element-735">
            See what our customers have to say
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-736">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-[#252525]/50 backdrop-blur-sm border border-[#2A2A2A] rounded-2xl p-8 hover:border-[#F1B530]/30 transition-all duration-300 hover:-translate-y-1" data-id="element-737">
              <div className="flex gap-1 mb-6" data-id="element-738">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-[#F1B530] fill-current" data-id="element-739" />)}
              </div>

              <QuoteIcon className="w-10 h-10 text-[#F1B530]/20 mb-4" data-id="element-740" />

              <p className="font-['Inter'] text-[#F5F5F5] mb-8 leading-relaxed font-light" data-id="element-741">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4" data-id="element-742">
                <img src={testimonial.image} alt={testimonial.author} className="w-12 h-12 rounded-full object-cover border-2 border-[#F1B530]/20" data-id="element-743" />
                <div data-id="element-744">
                  <div className="font-['Inter'] font-semibold text-[#F5F5F5]" data-id="element-745">
                    {testimonial.author}
                  </div>
                  <div className="font-['Inter'] text-sm text-[#A0A0A0]" data-id="element-746">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
function BoltAddOns() {
  const addOns = [{
    icon: PhoneForwardedIcon,
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&q=80',
    name: 'Live Transfer',
    price: 'AUD $99',
    setup: 'one-time setup',
    features: ['Instant Escalation for Time Sensitive Opportunities', 'Transfers With Full Caller Context', 'Smart Routing Based on Your Real Business Rules']
  }, {
    icon: MessageCircleIcon,
    image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=800&q=80',
    name: 'FAQ Handling',
    price: 'AUD $299',
    setup: 'one-time fee',
    features: ['Turn AI agent into trained front-line knowledge assistant', 'Fenced responses using only approved information', 'Clear brand-safe responses', 'Faster resolution & reduced message volume']
  }, {
    icon: CalendarCheckIcon,
    image: 'https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=800&q=80',
    name: 'Appointment Booking',
    price: 'AUD $399',
    setup: 'one-time setup',
    features: ['Real-time calendar syncing (Google, Outlook, etc.)', 'Automated booking and confirmation', 'Custom booking rules', 'Caller notifications and internal alerts']
  }];
  return <section className="w-full bg-[#0F0F0F] py-28 md:py-36 relative overflow-hidden" data-id="element-747">
      {/* Vertical line accents */}
      <div className="absolute left-1/4 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[#F1B530]/20 to-transparent" data-id="element-748"></div>
      <div className="absolute right-1/4 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[#F1B530]/20 to-transparent" data-id="element-749"></div>

      <div className="max-w-7xl mx-auto px-8 md:px-12 relative z-10" data-id="element-750">
        <div className="text-center mb-20" data-id="element-751">
          <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl text-[#F5F5F5] mb-6 tracking-tight" data-id="element-752">
            Universal Add-Ons
          </h2>
          <p className="font-['Inter'] text-lg text-[#A0A0A0] max-w-3xl mx-auto font-light" data-id="element-753">
            Available for all plans to extend your AI answering service
            capabilities
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-754">
          {addOns.map((addOn, index) => {
          const Icon = addOn.icon;
          return <div key={index} className="group bg-[#1A1A1A] rounded-2xl overflow-hidden border border-[#2A2A2A] hover:border-[#F1B530]/50 transition-all duration-300 hover:-translate-y-1" data-id="element-755">
                <div className="relative h-48 overflow-hidden bg-[#252525]" data-id="element-756">
                  <img src={addOn.image} alt={addOn.name} className="w-full h-full object-cover opacity-40 group-hover:opacity-60 transition-opacity duration-300" data-id="element-757" />
                  <div className="absolute inset-0 bg-gradient-to-b from-[#1A1A1A]/20 to-[#1A1A1A]" data-id="element-758"></div>
                  <div className="absolute bottom-4 left-4 w-14 h-14 bg-[#F1B530] rounded-xl flex items-center justify-center" data-id="element-759">
                    <Icon className="w-7 h-7 text-[#0F0F0F]" data-id="element-760" />
                  </div>
                </div>

                <div className="p-10" data-id="element-761">
                  <h3 className="font-['Poppins'] font-bold text-2xl text-[#F5F5F5] mb-3" data-id="element-762">
                    {addOn.name}
                  </h3>

                  <div className="mb-8" data-id="element-763">
                    <span className="font-['Poppins'] font-semibold text-2xl text-[#F1B530]" data-id="element-764">
                      {addOn.price}
                    </span>
                    <span className="text-[#A0A0A0] font-['Inter'] text-sm ml-2" data-id="element-765">
                      {addOn.setup}
                    </span>
                  </div>

                  <ul className="space-y-4" data-id="element-766">
                    {addOn.features.map((feature, idx) => <li key={idx} className="flex items-start" data-id="element-767">
                        <span className="text-[#F1B530] mr-3 flex-shrink-0 text-lg" data-id="element-768">
                          •
                        </span>
                        <span className="font-['Inter'] text-[#F5F5F5] text-sm leading-relaxed font-light" data-id="element-769">
                          {feature}
                        </span>
                      </li>)}
                  </ul>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}
function BoltAdvancedAutomation() {
  const capabilities = [{
    icon: WorkflowIcon,
    text: 'Route leads intelligently'
  }, {
    icon: ZapIcon,
    text: 'Trigger automated workflows'
  }, {
    icon: DatabaseIcon,
    text: 'Sync directly into CRMs'
  }, {
    icon: BrainCircuitIcon,
    text: 'Collect structured information'
  }];
  return <section className="w-full bg-[#1A1A1A] py-28 md:py-36 relative overflow-hidden" data-id="element-770">
      {/* Radial gradient background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(241,181,48,0.05),transparent_50%)]" data-id="element-771"></div>

      <div className="max-w-6xl mx-auto px-8 md:px-12 text-center relative z-10" data-id="element-772">
        <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl lg:text-6xl mb-6 tracking-tight text-[#F5F5F5]" data-id="element-773">
          AI Automation Customisation Advanced
        </h2>
        <p className="font-['Inter'] font-light text-xl md:text-2xl text-[#A0A0A0] mb-10" data-id="element-774">
          Automate More Than Calls. Automate Your Entire Frontline.
        </p>

        <p className="font-['Inter'] text-lg text-[#A0A0A0] max-w-4xl mx-auto mb-16 leading-relaxed font-light" data-id="element-775">
          For businesses handling 500+ calls per month, unlock advanced
          capabilities that transform your AI answering service into a complete
          frontline automation platform.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-776">
          {capabilities.map((capability, index) => {
          const Icon = capability.icon;
          return <div key={index} className="bg-[#252525] rounded-2xl p-8 border border-[#2A2A2A] hover:border-[#F1B530]/30 transition-all duration-300 h-full flex flex-col items-center justify-center min-h-[180px] group" data-id="element-777">
                <div className="w-12 h-12 rounded-xl bg-[#F1B530]/10 flex items-center justify-center mb-5 group-hover:bg-[#F1B530]/20 transition-colors duration-300" data-id="element-778">
                  <Icon className="w-6 h-6 text-[#F1B530]" data-id="element-779" />
                </div>
                <p className="font-['Inter'] text-[#F5F5F5] font-light text-center" data-id="element-780">
                  {capability.text}
                </p>
              </div>;
        })}
        </div>

        <div className="mb-16 relative" data-id="element-781">
          <div className="bg-[#252525] rounded-2xl p-8 border border-[#2A2A2A] max-w-4xl mx-auto" data-id="element-782">
            <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80" alt="Automation workflow visualization" className="w-full h-64 object-cover rounded-xl opacity-50" data-id="element-783" />
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-784">
              <div className="bg-[#0F0F0F]/80 backdrop-blur-sm border border-[#F1B530]/50 rounded-xl px-8 py-4" data-id="element-785">
                <p className="font-['Inter'] text-[#F1B530] font-semibold text-lg" data-id="element-786">
                  Complete Workflow Automation
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-[#252525] rounded-2xl p-10 border border-[#2A2A2A] mb-12 max-w-3xl mx-auto" data-id="element-787">
          <h3 className="font-['Inter'] font-semibold text-xl mb-6 text-[#F5F5F5]" data-id="element-788">
            Extended Capabilities Include:
          </h3>
          <ul className="font-['Inter'] text-[#A0A0A0] space-y-3 text-left max-w-2xl mx-auto font-light" data-id="element-789">
            <li data-id="element-790">• Support multi-step decision trees</li>
            <li data-id="element-791">• Extended conversational capabilities</li>
            <li data-id="element-792">• Custom API integrations</li>
            <li data-id="element-793">• Advanced data collection and processing</li>
            <li data-id="element-794">• Bespoke workflow automation</li>
          </ul>
        </div>

        <Button size="lg" data-id="element-795">Contact Sales</Button>
      </div>
    </section>;
}
function BoltFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'How does the AI answering service work?',
    answer: 'Our AI receptionist answers calls 24/7, captures caller information, handles FAQs, and can even book appointments. It integrates seamlessly with your existing systems and can be customized to match your business needs.'
  }, {
    question: 'Can I customize the greeting and responses?',
    answer: 'Absolutely! You can fully customize your company greeting, upload FAQs, set routing rules, and define your brand voice. The AI learns from your business to provide accurate, on-brand responses.'
  }, {
    question: "What happens if the AI can't handle a call?",
    answer: 'The AI can transfer calls to your team with full context when needed. You set the rules for when calls should be escalated, ensuring important matters always reach the right person.'
  }, {
    question: 'How quickly can I get started?',
    answer: "Setup takes less than 5 minutes. Simply sign up, customize your greeting and settings, forward your number, and you're live. We provide step-by-step guidance throughout the process."
  }, {
    question: 'Is there a contract or commitment?',
    answer: 'No long-term contracts required. Start with our 7-day free trial, then choose a monthly plan that fits your needs. You can upgrade, downgrade, or cancel anytime.'
  }];
  return <section className="w-full bg-[#1A1A1A] py-28 md:py-36 relative overflow-hidden" data-id="element-796">
      {/* Gradient accents */}
      <div className="absolute top-20 left-20 w-64 h-64 bg-[#F1B530] opacity-10 rounded-full blur-3xl" data-id="element-797"></div>
      <div className="absolute bottom-40 right-20 w-80 h-80 bg-[#D09F2B] opacity-10 rounded-full blur-3xl" data-id="element-798"></div>

      <div className="max-w-4xl mx-auto px-8 md:px-12 relative z-10" data-id="element-799">
        <div className="text-center mb-16" data-id="element-800">
          <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl mb-6 bg-gradient-to-r from-[#F5F5F5] via-[#F1B530] to-[#F5F5F5] bg-clip-text text-transparent" data-id="element-801">
            Frequently Asked Questions
          </h2>
          <p className="font-['Inter'] text-lg text-[#A0A0A0] font-light" data-id="element-802">
            Everything you need to know about our AI answering service
          </p>
        </div>

        <div className="space-y-4" data-id="element-803">
          {faqs.map((faq, index) => <div key={index} className="bg-[#252525]/50 backdrop-blur-sm border border-[#2A2A2A] rounded-2xl overflow-hidden transition-all duration-300 hover:border-[#F1B530]/30" data-id="element-804">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-8 py-6 flex items-center justify-between text-left" data-id="element-805">
                <span className="font-['Inter'] font-semibold text-xl text-[#F5F5F5] pr-8" data-id="element-806">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-[#F1B530] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-807" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`} data-id="element-808">
                <div className="px-8 pb-6" data-id="element-809">
                  <p className="font-['Inter'] text-[#A0A0A0] leading-relaxed font-light" data-id="element-810">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
export function BoltInspiredBase() {
  return <div className="w-full min-h-screen bg-[#0F0F0F]" data-id="element-811">
      <GradientHero data-id="element-812" />
      <TrustBadges data-id="element-813" />
      <BoltValueProposition data-id="element-814" />
      <BoltFeatureShowcase data-id="element-815" />
      <BoltIndustryBenefits data-id="element-816" />
      <BoltPricingPlans data-id="element-817" />
      <BoltTestimonials data-id="element-818" />
      <BoltAddOns data-id="element-819" />
      <BoltAdvancedAutomation data-id="element-820" />
      <BoltFAQ data-id="element-821" />
    </div>;
}